import React, { memo } from 'react';
import { Plus } from 'lucide-react';

// 🚀 메모이제이션된 새 콘텐츠 추가 카드 컴포넌트
const AddQuizCard = memo(({ 
  onClick 
}) => {
  return (
    <div 
      className="add-quiz-card" 
      onClick={onClick}
      style={{
        backgroundColor: 'var(--gray-50)',
        border: '2px dashed var(--gray-300)',
        borderRadius: 'var(--radius-lg)',
        padding: 'clamp(var(--spacing-lg), 5vw, var(--spacing-2xl))',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '180px'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--primary-light)';
        e.currentTarget.style.borderColor = 'var(--primary)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'var(--gray-50)';
        e.currentTarget.style.borderColor = 'var(--gray-300)';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <div style={{ 
        marginBottom: 'var(--spacing-md)',
        color: 'var(--gray-400)'
      }}>
        <Plus size={48} />
      </div>
      <h3 style={{ 
        fontSize: 'var(--font-lg)', 
        fontWeight: 600, 
        color: 'var(--gray-700)',
        marginBottom: 'var(--spacing-xs)',
        margin: 0,
        textAlign: 'center',
        lineHeight: '1.3'
      }}>
        새 콘텐츠 추가
      </h3>
      <p style={{ 
        fontSize: 'var(--font-sm)', 
        color: 'var(--gray-500)',
        margin: 0,
        textAlign: 'center',
        lineHeight: '1.4',
        wordBreak: 'keep-all'
      }}>
        클릭하여 새로운 퀴즈를 만들어보세요
      </p>
    </div>
  );
});

AddQuizCard.displayName = 'AddQuizCard';

export default AddQuizCard;
